import React from "react";
import ProductCityLevelList from "./ProductCityLevelList";
import AddUpdateProductCityLevelPage from "./AddUpdateProductCityLevelPage";
import {
  IProductCityLevelPageProps,
  ICustomerPageState,
} from "../../../interfaces/Index";
import HeadingText from "../../common/HeadingText/HeadingText";

export default class ProductCityLevelPage extends React.Component<
  IProductCityLevelPageProps,
  ICustomerPageState
> {
  constructor(props: IProductCityLevelPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      selectedProductCityLevel: null,
      isProductCityLevelAddUpdate: false,
      searchText: "",
      selectedCity: "",
      currentListPosition: 0,
      currentLocation: "",
      storageBlock: "GENERAL",
    };
  }

  renderAddUpdateProductCityLevelPage = () => {
    const { isEdit, selectedProductCityLevel } = this.state;
    const {
      isLoading,
      isError,
      error,
      isProductCityLevelAdded,
      isProductCityLevelUpdated,
      isProductCityLevelDetailsFetched,
      productCityLevelDetails,
      clearProductCityLevelDetails,
      fetchProductCityLevelBrands,
      productCityLevelFetchWareHouseNames,
      fetchProductCityLevelInventory,
      productCityLevelInventory,
      isProductCityLevelInventoryFetched,
      updateProductCityLevelInventory,
      odooTax,
      isOdooTaxFetched,
      productCityLevelFetchTaxFromOdoo,
      fetchCities,
      citiesList,
      isCityListFetched,
      roles,
    } = this.props;
    const { selectedCity } = this.state;

    return (
      <AddUpdateProductCityLevelPage
        {...this.props}
        productCityLevel={selectedProductCityLevel}
        isEdit={isEdit}
        backButtonHandler={this.navigateBackToListingPage}
        isLoading={isLoading}
        isError={isError}
        error={error}
        isProductCityLevelAdded={isProductCityLevelAdded}
        isProductCityLevelUpdated={isProductCityLevelUpdated}
        isProductCityLevelDetailsFetched={isProductCityLevelDetailsFetched}
        productCityLevelDetails={productCityLevelDetails}
        clearProductCityLevelDetails={clearProductCityLevelDetails}
        fetchProductCityLevelBrands={fetchProductCityLevelBrands}
        productCityLevelFetchWareHouseNames={
          productCityLevelFetchWareHouseNames
        }
        fetchProductCityLevelInventory={fetchProductCityLevelInventory}
        productCityLevelInventory={productCityLevelInventory}
        isProductCityLevelInventoryFetched={isProductCityLevelInventoryFetched}
        updateProductCityLevelInventory={updateProductCityLevelInventory}
        odooTax={odooTax}
        isOdooTaxFetched={isOdooTaxFetched}
        productCityLevelFetchTaxFromOdoo={productCityLevelFetchTaxFromOdoo}
        fetchCities={fetchCities}
        citiesList={citiesList}
        isCityListFetched={isCityListFetched}
        selectedCity={selectedCity}
        roles={roles}
      />
    );
  };
  renderProductCityLevelListing = () => {
    const {
      fetchProductCityLevels,
      productsCityLevel,
      isFetchProductCityLevelLoading,
      isFetchProductCityLevelError,
      error,
      pagination,
      bulkUploadProductCityLevel,
      isProductCityLevelBulkUploaded,
      isProductCityLevelBulkUploading,
      isProductCityLevelBulkUploadingError,
      inventoryUploadProductCityLevel,
      bulkUploadNewCityLevelProductPrice,
      isProductCityLevelInventoryUploaded,
      isProductCityLevelInventoryUploading,
      isProductCityLevelInventoryUploadingError,
      isNewCityLevelProductPricesUploading,
      isNewCityLevelProductPricesUploaded,
      isNewCityLevelProductPricesUploadingError,
      isProductCityLevelAdded,
      isProductCityLevelUpdated,
      citiesList,
      fetchCities,
      isCityListFetched,
      roles,
    } = this.props;
    const {
      isProductCityLevelAddUpdate,
      searchText,
      selectedCity,
      currentListPosition,
      currentLocation,
    } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Products" isMainHeading={true} />
        </section>
        <ProductCityLevelList
          fetchProductCityLevels={fetchProductCityLevels}
          productsCityLevel={productsCityLevel}
          pagination={pagination}
          isLoading={isFetchProductCityLevelLoading}
          isError={isFetchProductCityLevelError}
          error={error}
          isProductCityLevelAddedorUpdated={isProductCityLevelAddUpdate}
          currentLocation={currentLocation}
          isProductCityLevelAdded={isProductCityLevelAdded}
          addUpdatePageHandler={this.toggleAddUpdateProductCityLevelPage}
          uploadBulkProductCityLevel={bulkUploadProductCityLevel}
          bulkUploadNewCityLevelProductPrice={
            bulkUploadNewCityLevelProductPrice
          }
          isProductCityLevelBulkUploaded={isProductCityLevelBulkUploaded}
          isProductCityLevelBulkUploading={isProductCityLevelBulkUploading}
          isProductCityLevelBulkUploadingError={
            isProductCityLevelBulkUploadingError
          }
          uploadInventoryProductCityLevel={inventoryUploadProductCityLevel}
          isProductCityLevelInventoryUploaded={
            isProductCityLevelInventoryUploaded
          }
          isProductCityLevelInventoryUploading={
            isProductCityLevelInventoryUploading
          }
          isProductCityLevelInventoryUploadingError={
            isProductCityLevelInventoryUploadingError
          }
          isNewCityLevelProductPricesUploading={
            isNewCityLevelProductPricesUploading
          }
          isNewCityLevelProductPricesUploaded={
            isNewCityLevelProductPricesUploaded
          }
          isNewCityLevelProductPricesUploadingError={
            isNewCityLevelProductPricesUploadingError
          }
          isProductCityLevelUpdated={isProductCityLevelUpdated}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
          citiesList={citiesList}
          fetchCities={fetchCities}
          isCityListFetched={isCityListFetched}
          selectedCity={selectedCity}
          roles={roles}
        />
      </>
    );
  };

  toggleAddUpdateProductCityLevelPage = (
    isEdit: boolean = false,
    selectedProductCityLevel: any = null,
    searchText: string = "",
    selectedCity: object = {},
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedProductCityLevel: selectedProductCityLevel,
      searchText: searchText,
      selectedCity: selectedCity,
      currentListPosition: currentScroll,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean, currentLocation: any) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isProductCityLevelAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
      currentLocation: currentLocation,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderAddUpdateProductCityLevelPage()
          : this.renderProductCityLevelListing()}
      </div>
    );
  }
}
